export const NAVIGATE_TO_URL = 'ExternalUriInterface.v1_0.NavigateToExternalUriMethod';
export const DOWNLOAD_FROM_URL = 'ExternalUriInterface.v1_0.DownloadFromExternalUriMethod';
